import { createFileRoute } from "@tanstack/react-router";
import { RegisterComponent } from "../components/Routing/Register";

export const Route = createFileRoute("/register")({
  component: RegisterComponent,
  staticData: { titleKey: "common.register" },
});
